import React, {useEffect} from 'react'
import { useAuth } from '../../context/AuthContext'
import ProfileDashboard from '../profiles/playerDashboard'
import Profile from '../profiles/StateProfile'
import { useNavigate } from 'react-router-dom'

function Profiles() {
    const { userData,isAuthenticated } = useAuth()
    const navigate = useNavigate()
    const component = {
        "player": <ProfileDashboard/>,
        "stateadmin": <Profile/>
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            if (!isAuthenticated) {
                navigate("/login"); // Default redirect; real redirect happens after login
            }
        }, 1000); // Wait for 1 second
        return () => clearTimeout(timer);
    }, [isAuthenticated]);

    return (
        <>
            {
                userData && userData.role && component[userData.role]
            }
        </>
    )
}

export default Profiles